export const DEFAULT_FIRM_ID    = 'firm-default-00000000-0000-0000-0000-000000000001';
export const DEFAULT_COMPANY_ID = 'company-default-00000000-0000-0000-0000-000000000001';

export function assertFirmId(
  firmId: string | null | undefined,
  context: string,
): string {
  if (!firmId || firmId === DEFAULT_FIRM_ID) {
    throw new Error(
      `[${context}] firmId not available — user may not be authenticated`,
    );
  }
  return firmId;
}

export function assertCompanyId(
  companyId: string | null | undefined,
  context: string,
): string {
  if (!companyId || companyId === DEFAULT_COMPANY_ID) {
    throw new Error(`[${context}] companyId not available`);
  }
  return companyId;
}
